import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

const portalRedirect = (props) => {
  let to;
  switch (props.user.role) {
    case 'groupleader':
      to = 'group';
      break;
    case 'groupmember':
      to = 'group';
      break;
    case 'schoolcontact':
      to = 'school';
      break;
    default:
      to = props.user.role;
      break;
  }
  return (
    <Redirect to={`/portal/${to}`} />
  );
};

export default connect(state => ({ user: state.user  }))(portalRedirect);



// WEBPACK FOOTER //
// ./src/components/portalRedirect.js